module.exports = __webpack_public_path__ + "9788f41e/img/SOURCERY_poweredby_web.9819842b.png";